import { RemoteGetAllCHMetrics } from 'data/usecases/dashboard';
import { GetAllCHMetrics } from 'domain/usecases/dashboard';
import { makeApiUrlCHMetrics } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllCHMetrics = (): GetAllCHMetrics =>
  new RemoteGetAllCHMetrics(makeApiUrlCHMetrics(), makeAxiosHttpClient());
